import { LoginReqI } from "_interfaces/auth-api.interfaces";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAppDispatch } from "store";
import { useNavigate } from "react-router-dom";
import { errorHandler } from "_services/errorHandler";
import { saveTokenAuth } from "store/auth";
import { ChangeEvent, useState } from "react";
import { useSimpleLoginServiceLoginMutation } from "_services/modules/simple-login";
import { useAppTranslation } from "locale/useAppTranslation";
import { useAuthServiceV1LoginMutation } from "_services/modules/auth";

const useLoginForm = () => {
  const [rememberMe, setRememberMe] = useState(false);
  const dispatch = useAppDispatch();
  const [login, { isLoading }] = useAuthServiceV1LoginMutation();
  const navigate = useNavigate();
  const { t } = useAppTranslation("login");

  const schema = yup
    .object({
      email: yup.string().email().required(),
      password: yup.string().required(),
    }).required();
  const {
    handleSubmit,
    formState: { errors },
    register,
  } = useForm<LoginReqI>({
    mode: "onSubmit",
    resolver: yupResolver(schema),
  });

  const submit = async (data: LoginReqI) => {
    const { email, password } = data;
    try {
      const res = await login({
        authLoginReq:
        {
          email: email!,
          password: password!,
        }
      }).unwrap();
      dispatch(saveTokenAuth({ token: res.access_token ?? "" }));
      // navigate("/");
    } catch (error) {
      errorHandler(error);
    }
  };

  const rememberMeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setRememberMe(e.target.checked);
  }

  const loginHandler = handleSubmit(submit)

  return {
    loginHandler,
    register,
    errors,
    isLoading,
    rememberMeHandler,
    rememberMe,
    t,
  };
};

export default useLoginForm;
